// A multi-select where one item stands alone ("No Momentum product", "Not applicable"): choosing it clears the others, and
// choosing another clears it. The control already holds the new selection when the change event arrives, so the caller keeps
// the previous one and passes it in.
export function exclusiveSelection(selected: string[], previous: string[], exclusiveId: string | undefined): string[] {
  if (!exclusiveId || !selected.includes(exclusiveId) || selected.length < 2) {
    return selected;
  }

  return previous.includes(exclusiveId) ? selected.filter((id) => id !== exclusiveId) : [exclusiveId];
}
